import { gql } from '@apollo/client'

import { VoMode } from './types'

// Defined inline (not via codegen) because codegen runs against a live schema
// that does not yet include `voiceoverShare` / `createVoiceoverShareToken`.
// Both queries select the SAME minimal content tree so the authenticated and
// shared views feed `extractVoiceovers` identical data.
const VO_MODE_FIELDS = gql`
  fragment VoModeFields on TourMode {
    id
    title
    tour {
      id
      title
    }
    pois {
      id
      title
      sections {
        id
        title
        nuggets {
          id
          title
          content {
            id
            type
            texts
            files {
              id
              fileName
              mimeType
              url
            }
          }
        }
      }
    }
  }
`

export const TOUR_MODE_VOICEOVER_QUERY = gql`
  query tourModeVoiceover($id: String!) {
    tourMode(id: $id) {
      ...VoModeFields
    }
  }
  ${VO_MODE_FIELDS}
`

export const VOICEOVER_SHARE_QUERY = gql`
  query voiceoverShare($token: String!) {
    voiceoverShare(token: $token) {
      ...VoModeFields
    }
  }
  ${VO_MODE_FIELDS}
`

export const CREATE_VOICEOVER_SHARE_TOKEN = gql`
  mutation createVoiceoverShareToken(
    $tourId: String!
    $modeId: String!
    $ttlDays: Int!
  ) {
    createVoiceoverShareToken(tourId: $tourId, modeId: $modeId, ttlDays: $ttlDays)
  }
`

export type TourModeVoiceoverData = { tourMode: VoMode | null }
export type TourModeVoiceoverVars = { id: string }

export type VoiceoverShareData = { voiceoverShare: VoMode | null }
export type VoiceoverShareVars = { token: string }

export type CreateShareTokenData = { createVoiceoverShareToken: string }
export type CreateShareTokenVars = {
  tourId: string
  modeId: string
  ttlDays: number
}

export const IMPORT_VOICEOVERS = gql`
  mutation importVoiceovers($file: Upload!) {
    importVoiceovers(file: $file) {
      matched
      total
      unmatched
      skipped
      tourId
      tourTitle
    }
  }
`

export type ImportVoiceoversData = {
  importVoiceovers: {
    matched: number
    total: number
    unmatched: string[]
    skipped: string[]
    tourId: string
    tourTitle?: string | null
  }
}
export type ImportVoiceoversVars = { file: File }
